import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
interface ButtonProps extends HTMLMotionProps<'button'> {
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  className?: string;
}
export function Button({
  children,
  variant = 'primary',
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'px-6 py-3 rounded-full font-semibold text-sm tracking-wide transition-colors flex items-center justify-center gap-2';
  const variants = {
    primary: 'bg-emerald-500 text-white hover:bg-emerald-400 shadow-lg shadow-emerald-500/20',
    secondary: 'bg-white text-slate-900 hover:bg-slate-100 shadow-lg',
    outline: 'border border-white/30 text-white hover:bg-white/10 backdrop-blur-sm'
  };
  return <motion.button className={`${baseStyles} ${variants[variant]} ${className}`} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} transition={{
    type: 'spring',
    stiffness: 400,
    damping: 17
  }} {...props} data-id="element-129">
      {children}
    </motion.button>;
}